import React, { memo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Trans } from 'react-i18next';
import { useHistory } from '@app/router';
import useUrlPrefix from '@app/hooks/useUrlPrefix';
import { getIsBannerVisible } from '@app/redux/ui/selectors';
import { getShipByDate } from '@app/redux/customer/selectors';
import { Button, TabletAndDesktop } from '@stockx/ui';
import { useFormatDate } from '@app/datetime';

const SellerShipBy = () => {
  const urlPrefix = useUrlPrefix();
  const history = useHistory();
  const formatDate = useFormatDate();

  const shipByDate = useSelector(getShipByDate);
  const isBannerOpen = useSelector((state) =>
    getIsBannerVisible(state, 'shipBy'),
  );

  const handleClick = useCallback(() => {
    history.push(`${urlPrefix}selling`);
  }, [history, urlPrefix]);

  if (!isBannerOpen) {
    return null;
  }

  return (
    <Button
      onClick={handleClick}
      variant="primary"
      textTransform="uppercase"
      borderRadius="0"
      fontSize="sm"
      minH="40px"
      data-component="SellerShipBy"
      width={'100%'}
    >
      <Trans
        i18nKey="seller_ship_by_banner"
        values={{
          date: formatDate(shipByDate, 'date_without_dow'),
        }}
        components={[
          <TabletAndDesktop key="0">
            <span />
          </TabletAndDesktop>,
          <span key="1" style={{ marginLeft: '0.25rem' }} />,
        ]}
      />
    </Button>
  );
};

export default memo(SellerShipBy);
